import { c as _c } from "react/compiler-runtime";
/**
  * Do not edit this file manually.
  * It is automatically generated.
  * Run `npm run svg:convert` to regenerate.
  */
import type React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
export default function LabProfileIcon(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M8.25 11.75V10.25H15.75V11.75H8.25ZM8.25 7.74998V6.25003H15.75V7.74998H8.25ZM5.99997 14.25H13.5C13.9448 14.25 14.3564 14.3462 14.7346 14.5385C15.1128 14.7308 15.4339 15.0026 15.698 15.3539L18 18.3539V4.30773C18 4.21798 17.9711 4.14426 17.9134 4.08656C17.8557 4.02886 17.782 4.00001 17.6922 4.00001H6.3077C6.21795 4.00001 6.14423 4.02886 6.08652 4.08656C6.02882 4.14426 5.99997 4.21798 5.99997 4.30773V14.25ZM6.3077 20H17.3673L14.5173 16.2712C14.3916 16.1058 14.242 15.9775 14.0683 15.8865C13.8945 15.7955 13.7051 15.75 13.5 15.75H5.99997V19.6923C5.99997 19.782 6.02882 19.8558 6.08652 19.9135C6.14423 19.9712 6.21795 20 6.3077 20ZM17.6922 21.5H6.3077C5.80257 21.5 5.375 21.325 5.025 20.975C4.675 20.625 4.5 20.1974 4.5 19.6923V4.30773C4.5 3.8026 4.675 3.37503 5.025 3.02503C5.375 2.67503 5.80257 2.50003 6.3077 2.50003H17.6922C18.1974 2.50003 18.625 2.67503 18.975 3.02503C19.325 3.37503 19.5 3.8026 19.5 4.30773V19.6923C19.5 20.1974 19.325 20.625 18.975 20.975C18.625 21.325 18.1974 21.5 17.6922 21.5Z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SvgIcon {...props}>{t0}</SvgIcon>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}